import { FormattedMessage } from 'react-intl';
import { DocumentSVG } from '../../../svgComponents/documentSVG';
import DocumentsByType from './DocumentsByType/DocumentsByType';
import styles from './UploadedDocuments.module.css';
import messages from './UploadedDocuments.messages';
import _ from 'lodash';

export const UploadedDocuments = ({ uploaded_documents }) => (
    <div className={styles.UploadedDocuments}>
        <div className={styles.title}>
            <FormattedMessage {...messages.title} />
        </div>
        <div className={styles.content}>
            {!_.isEmpty(uploaded_documents) ? (
                _.map(uploaded_documents, (doc, documentType) => (
                    <DocumentsByType
                        key={documentType}
                        documentIcon={<DocumentSVG />}
                        documentType={documentType}
                        documents={doc}
                    />
                ))
            ) : (
                <FormattedMessage {...messages.noUploadedDocuments} />
            )}
        </div>
    </div>
);
